module.exports = __webpack_public_path__ + "img/nav_home.a24fb57e.svg";